// extracted by mini-css-extract-plugin
export default {"leftSidebarContainer":"leftSidebarComponent_leftSidebarContainer__P9cq6"};